/* global $ */


const COMPONENT_NAME = "z-free-list" ;

export default function register(){
    class FreeListComponent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback(){
            this.init() ;
        }

        init(){
            // this.block = this.querySelector(".z-free-list-block") ;
            // if(!this.block){ 
            //     this.block = document.createElement("DIV") ;
            //     this.block.className = "z-free-list-block" ;
            //     this.block.innerHTML = this.innerHTML ;
            //     this.innerHTML = "" ;
            //     this.appendChild(this.block) ;
            // }
            let resourceUrl = this.getAttribute("z-resource-url") ;
            let openUrl = this.getAttribute("z-open-url") ;
            let fieldId = this.getAttribute("z-field-id") ;
            let modelDef = null;

            if(this.hasAttribute("z-model")){
                const model = this.getAttribute("z-model") ;
                const filter =  this.getAttribute("z-filter") ;
                if(model){
                    if(!resourceUrl){
                        resourceUrl =  "/api/rest/"+model ;
                    }
                    let schema = window.APP.schema ;
                    if(this.hasAttribute("z-app")){
                        schema = window.APPS[this.getAttribute("z-app")].schema ;
                        resourceUrl =  "/api/"+this.getAttribute("z-app")+"/rest/"+model ;
                    }
                    modelDef = schema.models.find(m => m.name === model) ;
                    if(filter){
                        resourceUrl += "?"+filter ;
                    }else if(modelDef && modelDef.columns && modelDef.columns.find(c=>c.name === "_index")){
                        resourceUrl += "?orderBy=_index" ;
                    }

                    if(!fieldId){
                        fieldId = "id" ;
                        if(modelDef){
                            const fieldPk = modelDef.columns.find(c => c.unique) ;
                            if(fieldPk){
                                fieldId = fieldPk.name ;
                            }
                        }
                    }

                    if(!this.hasAttribute("z-open-url")){
                        let currentHref = window.location.href ;
                        currentHref = currentHref.replace(/\/list\/{0,1}$/, "/form/read/{{"+fieldId+"}}") ;
                        let inRoutes = true ;
                        if(window.router){
                            const hashHref = currentHref.substring(currentHref.indexOf("#")+1) ;
                            inRoutes = window.router._routes.some(r=>r.regexp.test(hashHref)) ;
                        }
                        if(inRoutes){
                            openUrl = currentHref ;
                        }
                    }
                }
            }


            this.openUrl = openUrl ;

            if(openUrl){
                this.setAttribute("z-open-url", openUrl) ;
            }

            if(resourceUrl){
                this.setAttribute("z-bind-url", resourceUrl) ;
            }
            if(fieldId){
                this.setAttribute("z-field-id", fieldId) ;
            }
        }
    }
    customElements.define(COMPONENT_NAME, FreeListComponent);
}

